import { lazy } from 'react'
import { Navigate } from 'react-router-dom'
import { LoopModule } from 'src/services/openApiV2'

// Chargebacks
const Benchmarks = lazy(() => import('src/pages/members/Benchmarks/Benchmarks'))
const Chargebacks = lazy(() => import('src/pages/members/Chargebacks/Chargebacks'))
const ChargebacksHistoryStoreView = lazy(() => import('src/pages/members/HistoryByStore/pages/ChargebacksHistoryStoreView/ChargebacksHistoryStoreView'))

const ChargebacksDetails = lazy(() => import('src/pages/members/ChargebacksDetails/ChargebacksDetails'))
const IssueDiscovery = lazy(() => import('src/pages/members/IssueDiscovery/IssueDiscovery'))
const ChargebackDisputeConfigs = lazy(() => import('src/pages/members/ChargebackDisputeConfigs/ChargebackDisputeConfigs'))
const ChargebackConfigs = lazy(() => import('src/pages/members/ChargebackConfigs/ChargebackConfigs'))
const Errors = lazy(() => import('src/pages/members/Errors/Errors'))
const InAccurateOrders = lazy(() => import('src/pages/members/InAccurateOrders/InAccurateOrders'))

const MissedOrders = lazy(() => import('src/pages/members/MissedOrders/MissedOrders'))
const CancelledOrders = lazy(() => import('src/pages/members/CancelledOrders/CancelledOrders'))

const AddCCTVProvider = lazy(() => import('src/pages/members/CCTVSetup/AddCCTVProvider'))

export const existingRoutes = [
  // Legacy route redirects - automatically redirect to new /recover/* paths
  // Chargebacks routes → /recover/*
  {
    path: 'chargebacks',
    element: <Navigate to="/recover/overview" replace />
  }, // 280 pageviews → /recover/overview
  {
    path: 'chargebacks/overview',
    element: <Navigate to="/recover/overview" replace />
  },
  {
    path: 'chargebacks/stores/view',
    element: <Navigate to="/recover/stores-view" replace />
  },
  {
    path: 'chargebacks/matrix',
    element: <Navigate to="/recover/matrix" replace />
  },

  // Issue discovery routes → /recover/issue-discovery/*
  {
    path: 'errors/issue-discovery/:tab/:filter',
    element: <Navigate to="/recover/issue-discovery/discovery/by-reasons" replace />
  }, // 773 pageviews → /recover/issue-discovery/*
  {
    path: 'issue-discovery/:tab/:filter',
    element: <Navigate to="/recover/issue-discovery/discovery/by-reasons" replace />
  },
  {
    path: 'issue-discovery/:tab/:filter/:filterName',
    element: <Navigate to="/recover/issue-discovery/discovery/by-reasons" replace />
  },

  // Error/Order accuracy routes → /recover/order-accuracy/*
  {
    path: 'errors',
    element: <Navigate to={`/recover/order-accuracy/overview${window.location.search}`} replace />
  }, // 625 pageviews → /recover/order-accuracy/*
  {
    path: 'errors/overview',
    element: <Navigate to="/recover/order-accuracy/overview" replace />
  },
  {
    path: 'errors/inaccurate-orders',
    element: <Navigate to="/recover/order-accuracy/inaccurate" replace />
  },
  {
    path: 'errors/inaccurate-orders/:filter',
    element: <Navigate to="/recover/order-accuracy/inaccurate" replace />
  },
  {
    path: 'errors/missed-orders',
    element: <Navigate to="/recover/order-accuracy/missed" replace />
  },
  {
    path: 'errors/missed-orders/:filter',
    element: <Navigate to="/recover/order-accuracy/missed" replace />
  },
  {
    path: 'errors/cancelled-orders',
    element: <Navigate to="/recover/order-accuracy/cancelled" replace />
  },
  {
    path: 'errors/cancelled-orders/:filter',
    element: <Navigate to="/recover/order-accuracy/cancelled" replace />
  },

  // Configuration routes → /recover/configs/*
  {
    path: 'configurations/chargebacks/categories',
    element: <Navigate to="/recover/configs/categories" replace />
  },
  {
    path: 'configurations/chargebacks',
    element: <Navigate to="/recover/configs/locations" replace />
  }
]

export const moduleNamedRoutes = [
  {
    path: 'recover',
    element: <Chargebacks tabValue="overview" />,
    children: [
      { index: true, element: <Chargebacks tabValue="overview" /> },
      { path: 'overview', element: <Chargebacks tabValue="overview" /> },
      {
        path: 'stores-view',
        element: <ChargebacksHistoryStoreView />
      },
      {
        path: 'matrix',
        element: <ChargebacksDetails />
      },
      {
        path: 'issue-discovery/:tab/:filter',
        element: <IssueDiscovery />
      },
      {
        path: 'issue-discovery/:tab/:filter/:filterName',
        element: <IssueDiscovery />
      },
      {
        path: 'configs',
        children: [
          {
            index: true,
            element: (
              <Navigate
                to="/recover/configs/locations"
                replace
              />
            )
          },
          {
            path: 'locations',
            element: <ChargebackConfigs />
          },
          {
            path: 'categories',
            element: <ChargebackDisputeConfigs />
          }
        ]
      },
      {
        path: 'order-accuracy',
        children: [
          {
            path: 'overview',
            element: <Errors />
          },
          {
            path: 'cancelled',
            element: <CancelledOrders />
          },
          {
            path: 'inaccurate',
            element: <InAccurateOrders />
          },
          {
            path: 'missed',
            element: <MissedOrders />
          },
          {
            path: 'missed/:filter',
            element: <MissedOrders />
          },
          {
            path: 'cancelled/:filter',
            element: <CancelledOrders />
          }
        ]
      },
      {
        path: 'benchmarks',
        element: <Benchmarks module={LoopModule.RECOVER} />
      },
      {
        path: 'cctv-setup',
        element: <AddCCTVProvider />
      }
    ]
  }
]

export const recoverRoutes = [...existingRoutes, ...moduleNamedRoutes]
